<template>
  <div v-if="drawComponent">
    <secondary-sidebar v-if="id">
      <template slot="tabs">
        <li class="active">
          <a href="#general-tab" data-toggle="tab" class="legitRipple" aria-expanded="true">
            <!-- i class="icon-grid-alt"></i -->
            <span class="position-right">Info</span>
          </a>
        </li>

        <li class="" v-if="!isRejected()">
          <a href="#files-tab" data-toggle="tab" class="legitRipple" aria-expanded="false">
            <!-- i class="icon-menu6"></i -->
            <span class="position-right">Files</span>
          </a>
        </li>

        <li class="" v-if="!isRejected()">
          <a href="#messages-tab" data-toggle="tab" class="legitRipple" aria-expanded="false">
            <!-- i class="icon-menu6"></i -->
            <span class="position-right">Messages</span>
          </a>
        </li>
      </template>
      <template slot="tabcontent">
        <div class="tab-pane no-padding active" id="general-tab">
          <!-- Project -->
          <!-- User list -->
          <div class="sidebar-category">
            <div class="category-title">
              <span>Project</span>
              <ul class="icons-list">
                <li><a href="#" data-action="collapse"></a></li>
              </ul>
            </div>

            <div class="category-content">
              <project-view :entity="projectObject" layout="short"></project-view>
            </div>
          </div>
          <!-- /user list -->
          <!-- User list -->
          <div class="sidebar-category">
            <div class="category-title">
              <span>Sale status</span>
            </div>

            <div class="category-content">
              <span class="label label-block label-striped label-important">{{$formatter.formatFlowStatus(object.workflowStatus)}} <span v-if="$workflow.subflowActive(object, 'sale-' + object.workflowStatus) && $workflow.getSubflowStatus(object, 'sale-' + object.workflowStatus)"> &raquo; <i class="text-bold">{{$formatter.formatFlowStatus($workflow.getSubflowStatus(object, 'sale-' + object.workflowStatus))}}</i></span></span>
            </div>
          </div>
          <!-- /user list -->
          <!-- User list -->
          <div class="sidebar-category">
            <div class="category-title">
              <span>Agent data</span>
              <ul class="icons-list">
                <li><a href="#" data-action="collapse"></a></li>
              </ul>
            </div>

            <div class="category-content">
              <user-view :entity="object.creator" :allowEdit="false" :layout="'short'"></user-view>
            </div>
          </div>
          <!-- /user list -->
          <!-- User list -->
          <div class="sidebar-category">
            <div class="category-title">
              <span>Client data</span>
              <ul class="icons-list">
                <li><a href="#" data-action="collapse"></a></li>
              </ul>
            </div>

            <div class="category-content">
              <user-view :entity="object.client" :allowEdit="!isRejected()" :layout="!isRejected() ? 'sale' : 'short'"></user-view>
            </div>
          </div>
          <!-- /user list -->
        </div>
        <div class="tab-pane no-padding" id="files-tab">
          <div class="category-title">
            <span>Project files</span>
          </div>
          <div class="category-content clearfix">
            <model-files-list :condensed="true" :fileSlot="{code: 'project-public-files'}" :files="projectObject.modelFiles"></model-files-list>
          </div>
          <!-- Sale uploads -->
          <div class="category-title">
            <span>Sale files</span>
          </div>
          <div class="category-content clearfix">
            <template v-if="object.fileSlots">
              <template v-for="(slot, idx) in object.fileSlots">
                <div v-if="$fileslot.slotFilled(object, slot.code)" class="sidebar-category not-collapsible" :key="idx">
                  <div class="category-title">
                    <span>{{slot.title}}</span>
                  </div>
                  <div class="category-content clearfix">
                    <model-files-list :condensed="true" :fileSlot="slot" :files="files"></model-files-list>
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="tab-pane no-padding" id="messages-tab">
          <div class="sidebar-category">
            <div class="category-content no-padding">
              <div v-if="id" class="col-sm-12">
                <!-- Timeline :items="object.activityLogs"></Timeline -->
                <chat :slug="'chat-sale-'+object.id" v-if="object.id > 0" :panelized="false" :fullHeight="true" :hideUsernames="true"></chat>
              </div>
            </div>
          </div>
        </div>
      </template>
    </secondary-sidebar>
    <div class="row" style="display: table-cell" v-if="object.id > 0">
      <div class="col-sm-12 col-md-12">
        <div class="wizard" v-if="!isRejected()">
          <div class="steps clearfix">
            <ul role="tablist">
              <li role="tab" class="first disabled" aria-disabled="true" :class="{'done': wasOffer(), 'current': isOffer()}">
                <a id="steps-uid-3-t-0">
                  <span class="number">1</span> Offer created
                </a>
              </li>
              <li role="tab" class="disabled" aria-disabled="true" :class="{'done': wasOffer_Accepted()}">
                <a id="steps-uid-3-t-1">
                  <span class="number">2</span> Reservation accepted
                </a>
              </li>
              <li role="tab" class="disabled" aria-disabled="true" :class="{ 'done': wasReservation_Preparation(), 'current': isReservation_Preparation()}">
                <a id="steps-uid-3-t-2">
                  <span class="current-info audible">current step: </span>
                  <span class="number">3</span> Documents preparation
                </a>
              </li>
              <li role="tab" class="disabled" aria-disabled="true" :class="{'done': wasReservation(), 'current': isReservation_Review()}">
                <a id="steps-uid-3-t-4">
                  <span class="number">4</span> Documents review
                </a>
              </li>
              <li role="tab" class="disabled" aria-disabled="true" :class="{'done': wasSelling_ContractPreparation() || wasSelling_Review(), 'current': isSelling_ContractPreparation()}">
                <a id="steps-uid-3-t-5">
                  <span class="number">5</span> Contract draft preparation
                </a>
              </li>
              <li role="tab" class="disabled" aria-disabled="true" :class="{'done': wasSelling_PaymentSent(), 'current': wasSelling_Approved() && !wasSelling_PaymentSent()}">
                <a id="steps-uid-3-t-6">
                  <span class="number">6</span> Contract signing
                </a>
              </li>
              <li role="tab" class="disabled last" aria-disabled="true" :class="{'done': isSold(), 'current': wasSelling_PaymentSent() && !isSold()}">
                <a id="steps-uid-3-t-7">
                  <span class="number">7</span> Payment &amp; Sale completed
                </a>
              </li>
            </ul>
          </div>
        </div>
        <panel :title="'Apartments'">
          <div slot="headingElements" v-if="canChangeReservation()">
            <a class="btn" :disabled="!canChangeReservation()" v-bind:class='{"btn-success": canChangeReservation(), "btn-warning btn-disabled": !canChangeReservation()}' @click.prevent='addApartmentClick'>
              <i class="icon-add"></i><span class="text-semibold">Add apartment</span>
            </a>
          </div>
          <div class="rejected" v-if="isRejected()"></div>
          <apartment-list
            :items="object.apartments"
            :columns="{status: true, deleteItem: canChangeReservation()}"
            :layout="'sale'"
            @itemDelete="deleteApartmentClick"
            @specialChanged="specialChanged"
            :specialSettings="{
              is_special_remark_rent: object.is_special_remark_rent,
              is_special_remark: object.is_special_remark,
              special_remark_rent: object.special_remark_rent,
              special_remark: object.special_remark,
              transfer_tax: parseFloat(projectObject.transfer_tax)
            }"
            :discount="object.loan_based < 1 ? 1 : 0"
          ></apartment-list>
        </panel>

        <!-- aparment add form/modal -->
        <modal id="apartmentAddForm" :size="'lg'" v-if="addApartmentMode">
          <div slot="header">
            <button type="button" class="close" @click.prevent="addApartmentClose()">×</button>
            <h5 class="modal-title">Add apartment</h5>
          </div>
          <div slot="body">
            <div class="row">
              <div class="col-sm-12">
                <apartment-list v-if="projectObject && projectObject.id"
                                :items="projectObject.apartments.filter(a => object.apartments.indexOf(a) === -1 )"
                                :columns="{editableStatus: false, status: true}"
                                @viewApartmentClick="selectApartmentClick"
                                @toggleSelect="selectApartmentClick"
                >
                </apartment-list>
              </div>
            </div>
          </div>
          <div slot="footer">
            <button type="submit" @click.prevent="addApartmentClose()" :disabled="errors.any()" class="btn btn-primary legitRipple">Ok</button>
          </div>
        </modal>
      </div>
      <!-- offer settings -->
      <div class="col-sm-12 col-md-12" v-if="isProposed() || (wasOffer() && !isRejected())">
        <panel>
          <div class="form-inline">
            <div class="row">
              <div class="col-sm-4 text-center">
                <div class="form-group">
                  <div class="row pl-20">
                    <label class="control-label">Contract Language: </label>
                  </div>
                  <div class="row pl-20">
                    <label class="radio-inline"><input type="radio" class="styled" @change="saveState" name="language" v-model="object.language" value="en" :disabled="!canChangeReservation()"/> English</label>
                    <label class="radio-inline"><input type="radio" class="styled" @change="saveState" name="language" v-model="object.language" value="fr" :disabled="!canChangeReservation()"/> French</label>
                    <label class="radio-inline"><input type="radio" class="styled" @change="saveState" name="language" v-model="object.language" value="nl" :disabled="!canChangeReservation()"/> Flamish</label>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 text-center">
                <div class="form-group">
                  <div class="row pl-20">
                    <label class="control-label">Client buying with credit: </label>
                  </div>
                  <div class="row pl-20">
                    <label class="radio-inline"><input type="radio" class="styled" @change="saveState" id="lby" name="loan_based" v-model.number="object.loan_based" :value="1" :disabled="!canChangeReservation()"/> Yes</label>
                    <label class="radio-inline"><input type="radio" class="styled" @change="saveState" id="lbn" name="loan_based" v-model.number="object.loan_based" :value="0" :disabled="!canChangeReservation()"/> No</label>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 text-center">
                <div class="form-group">
                  <div class="row pl-20">
                    <label class="control-label">Place of notary signing: </label>
                  </div>
                  <div class="row pl-20">
                    <label class="radio-inline"><input type="radio" class="styled" @change="saveState" name="sign_location" v-model="object.sign_location" value="cc" :disabled="!canChangeReservation()"/> Client country</label>
                    <label class="radio-inline"><input type="radio" class="styled" @change="saveState" name="sign_location" v-model="object.sign_location" value="de" :disabled="!canChangeReservation()"/> Germany</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </panel>
      </div>
      <div class="col-sm-12 col-md-12 mb-20" v-if="isProposed() || wasOffer">
        <div class="row">
          <div class="col-sm-12 text-center">
            <a class="btn btn-lg bg-indigo mr-10" @click.prevent="downloadPreReservation()">DOWNLOAD RESERVATION</a>
            <a class="btn btn-lg bg-orange mr-10" @click.prevent="downloadPreReservation(true)">DOWNLOAD BLANK RESERVATION</a>
            <a class="btn btn-lg btn-success mr-10" @click.prevent="acceptReservation()" v-if="isProposed()">RESERVATION APPROVED</a>
            <a class="btn btn-lg btn-danger mr-10" @click.prevent="declineReservation()" v-if="isProposed()">RESERVATION DECLINED</a>
          </div>
        </div>
      </div>
      <!-- loan settings -->
      <div class="col-sm-12 col-md-12" v-if="!isProposed() && !isRejected()">
        <panel title="Bank Country" v-if="object.loan_based > 0">
          <form class="form-horizontal">
            <div class="form-inline">
              <div class="row">
                <div class="col-sm-6 mb-20">
                  <label class="checkbox-inline mr-20">
                    <input type="checkbox" @change="saveState" v-model="object.bank_belgian" :disabled="!canChangeReservation()"/> Belgium
                  </label>
                  <label class="checkbox-inline">
                    <input type="checkbox" @change="saveState" v-model="object.bank_german" :disabled="!canChangeReservation()"/> Germany
                  </label>
                </div>
              </div>
              <!-- belgian bank part -->
              <div class="row" v-if="object.bank_belgian">
                <div class="col-sm-12">
                  <h3 class="panel-title mb-20">Belgium Bank Files</h3>
                </div>
                <div class="row">
                  <div class="form-group col-sm-6">
                    <label class="col-sm-3 control-label">Bank name</label>
                    <input type="text" @change="saveState" class="col-sm-9 form-control form-control-small-height" :readonly="!canChangeReservation()" v-model="object.bank_name_belgian"/>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-sm-3 control-label">Credit Amount</label>
                    <input type="number" min="0" @change="saveState" class="col-sm-9 form-control form-control-small-height" :readonly="!canChangeReservation()" v-model.number="object.bank_amount_belgian"/>
                  </div>
                </div>
                <template v-for="(slot, idx) in $fileslot.__getSlotsByCode(object, slotCodes['reservation-credit']['belgian'])">
                  <!-- slot-view-credit
                    :key="idx"
                    :parentObject="object"
                    :fileSlot="slot"
                    :files="files"
                    :uploadUrl="uploadUrl"
                    :canUpload="canUpload(slot.code, 'sale-credit-slot')"
                    :canDeleteFile="canDeleteFile(slot.code, 'sale-credit-slot')"
                    :deleteFile="deleteFile"
                    :allowReview="(_is('agencyAgent') || _is('agencyAdmin')) && (isReservation_Review() && slotStatusIn(['rejected'], slot.code, 'sale-credit-slot'))"
                    :allowApproveReject="(_is('agencyAdmin') || _is('superAdmin') || _is('financialAdmin')) && isReservation_Review() && !slotApproved(slot.code, 'sale-credit-slot')"
                    :actionsVisible="!slotStatus(slot.code, 'sale-credit-slot').match(/^rejected/)"
                    :rejectedVisible="slotStatus(slot.code, 'sale-credit-slot') === 'rejected'"
                    :workflowName="'sale-credit-slot'"
                    :workflowApprovedStatus="'approved'"
                    :workflowRejectedStatus="'rejected'"
                    @approveSlot="approveSlot"
                    @rejectSlot="rejectSlot"
                    @unrejectSlot="unrejectSlot"
                    @uploadComplete="uploadComplete"
                    @uploadError="uploadError"
                  / -->
                </template>
              </div>
              <!-- german bank part -->
              <div class="row" v-if="object.bank_german">
                <div class="col-sm-12">
                  <h3 class="panel-title mb-20">German Bank Files</h3>
                </div>
                <div class="row">
                  <div class="form-group col-sm-6">
                    <label class="col-sm-3 control-label">Bank name</label>
                    <input type="text" @change="saveState" class="col-sm-9 form-control form-control-small-height" :readonly="!canChangeReservation()" v-model="object.bank_name_german"/>
                  </div>
                  <div class="form-group col-sm-6">
                    <label class="col-sm-3 control-label">Credit Amount</label>
                    <input type="number" min="0" @change="saveState" class="col-sm-9 form-control form-control-small-height" :readonly="!canChangeReservation()" v-model.number="object.bank_amount_german"/>
                  </div>
                </div>
                <template v-for="(slot, idx) in $fileslot.__getSlotsByCode(object, slotCodes['reservation-credit']['german'])">
                  <!-- slot-view-credit
                    :key="idx"
                    :parentObject="object"
                    :fileSlot="slot"
                    :files="files"
                    :uploadUrl="uploadUrl"
                    :canUpload="canUpload(slot.code, 'sale-credit-slot') && slotStatusIn(['rejected','initial'], slot.code, 'sale-credit-slot')"
                    :canDeleteFile="canDeleteFile(slot.code, 'sale-credit-slot')"
                    :deleteFile="deleteFile"
                    :allowReview="(_is('agencyAgent') || _is('agencyAdmin')) && (isReservation_Review() && slotStatusIn(['rejected','initial'], slot.code, 'sale-credit-slot'))"
                    :allowApproveReject="(_is('agencyAdmin') || _is('superAdmin') || _is('financialAdmin')) && isReservation_Review() && !slotApproved(slot.code, 'sale-credit-slot')"
                    :actionsVisible="!slotStatus(slot.code, 'sale-credit-slot').match(/^rejected/)"
                    :rejectedVisible="slotStatus(slot.code, 'sale-credit-slot') === 'rejected'"
                    :isRequiredState="isReservation_Review()"
                    :waitingUploadVisible="!(_is('agencyAgent') || _is('agencyAdmin')) && !canUpload(slot.code, 'sale-credit-slot') && !slotOkay(slot.code)"
                    :workflowName="'sale-credit-slot'"
                    :workflowApprovedStatus="'approved'"
                    :workflowRejectedStatus="'rejected'"
                    @approveSlot="approveSlot"
                    @rejectSlot="rejectSlot"
                    @unrejectSlot="unrejectSlot"
                    @uploadComplete="uploadComplete"
                    @uploadError="uploadError"
                    @slotSentToReview="sendSlotToReview"
                  / -->
                </template>
              </div>
            </div>
          </form>
        </panel>
      </div>
      <!-- /offer settings -->
      <div class="col-sm-12 col-md-12" v-if="!isProposed() && !isRejected()">
        <panel :title="'Reservation Documents'">
          <!-- uploads -->
          <div class="form-inline">
            <div class="row">
              <div class="col-sm-12">
                <div class="row" v-for="(slot, idx) in $fileslot.__getSlotsByCode(object, slotCodes['reservation'])" :key="idx">
                  <div class="col-sm-2">
                    <strong>{{slot.title}}:</strong>
                  </div>
                  <div class="col-sm-7">
                    <div class="row">
                      <UploadForm v-if="uploadUrl && canUpload(slot.code)"
                                  accept="*/*"
                                  @uploadComplete="uploadComplete"
                                  @uploadError="uploadError"
                                  :multiple="true"
                                  :label="''"
                                  labelIconClass="icon-add"
                                  :showHint="true"
                                  :uploadUrl="uploadUrl"
                                  :fileSlot="slot.code"
                      ></UploadForm>
                    </div>
                    <div v-if="!canUpload(slot.code) && !slotOkay(slot.code)" class="alert alert-bordered alert-warning">
                      <p>
                        Waiting for upload
                      </p>
                    </div>
                    <div v-else-if="!slotStatus(slot.code).match(/^rejected/) && isReservation_Review() && (!slotApprovedBy('agencyAdmin', slot.code) || !slotApprovedBy('superAdmin', slot.code))" class="alert alert-bordered" :class="{'alert-warning': (!slotApprovedBy('agencyAdmin', slot.code)) || (!slotApprovedBy('superAdmin', slot.code))}">
                      <p v-if="!slotApprovedBy('agencyAdmin', slot.code)">
                        <span class="text-bold">Senior Agency</span> approval pending
                      </p>
                      <p v-if="slotApprovedBy('agencyAdmin', slot.code) && !slotApprovedBy('superAdmin', slot.code)">
                        <span class="text-bold">SAAD Immo</span> approval pending
                      </p>
                    </div>
                    <template v-else-if="slotStatus(slot.code).match(/^rejected/)">
                      <div class="alert alert-bordered alert-danger" :class="{'mb-0': slotStatusReason(slot.code)}">
                        <p v-if="slotStatus(slot.code) === 'rejected_by_senior'">
                          <span class="text-bold">Senior Agency</span> rejected documents
                        </p>
                        <p v-if="slotStatus(slot.code) === 'rejected_by_saad'">
                          <span class="text-bold">SAAD Immo</span> rejected documents
                        </p>
                      </div>
                      <div v-if="slotStatusReason(slot.code)" class="alert alert-bordered bg-grey">
                        {{slotStatusReason(slot.code)}}
                      </div>
                    </template>
                    <div v-else-if="!isAuthor(object) && !slotStatus(slot.code).match(/^rejected/) && !isReservation_Review() && (!slotApprovedBy('agencyAdmin', slot.code) || !slotApprovedBy('superAdmin', slot.code))" class="alert alert-bordered" :class="{'alert-warning': (!slotApprovedBy('agencyAdmin', slot.code)) || (!slotApprovedBy('superAdmin', slot.code))}">
                      <p>
                        Waiting for review submission
                      </p>
                    </div>
                    <div class="row">
                      <model-files-list :fileSlot="slot" :canDeleteFile="canDeleteFile()" :files="files" @deleteFile="deleteFile"></model-files-list>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <template v-if="(_is('agencyAgent') || _is('agencyAdmin')) && (isReservation_Review() && slotStatusIn(['rejected_by_saad', 'rejected_by_senior'], slot.code))">
                      <a @click.prevent="sendSlotToReview(slot.code)" class="btn btn-primary">Submit on review</a>
                    </template>
                    <template v-if="_is('agencyAdmin') && (isReservation_Review() && !slotApprovedBy('agencyAdmin', slot.code))">
                      <template v-if="!slotStatus(slot.code).match(/^rejected/)">
                        <a @click.prevent="approveSlot({code: slot.code, title: slot.title})" class="btn btn-success mr-10">Approve</a><a @click.prevent="rejectSlot({code: slot.code, title: slot.title})" class="btn btn-danger">Reject</a>
                      </template>
                      <template v-else-if="slotStatus(slot.code) === 'rejected_by_senior'">
                        <div class="alert alert-bordered pt-5">
                          <span class="text-danger mr-10">REJECTED</span> <a class="btn btn-default" title="Undo choice" @click.prevent="unrejectSlot({code: slot.code, title: slot.title})"><i class="icon-cross2"></i></a>
                        </div>
                      </template>
                    </template>
                    <template v-if="_is('superAdmin') && (isReservation_Review() && slotApprovedBy('agencyAdmin', slot.code) && !slotApprovedBy('superAdmin', slot.code))">
                      <template v-if="!slotStatus(slot.code).match(/^rejected/)">
                        <a @click.prevent="approveSlot({code: slot.code, title: slot.title})" class="btn btn-success mr-10">Approve</a><a @click.prevent="rejectSlot({code: slot.code, title: slot.title})" class="btn btn-danger">Reject</a>
                      </template>
                      <template v-else>
                        <div class="alert alert-bordered pt-5">
                          <span class="text-danger mr-10">REJECTED</span> <a class="btn btn-default" title="Undo choice" @click.prevent="unrejectSlot({code: slot.code, title: slot.title})"><i class="icon-cross2"></i></a>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
                <template v-if="(_is('agencyAgent') || _is('agencyAdmin')) && isReservation_Preparation()">
                  <div class="row">
                    <div class="col-sm-2">
                      <a @click.prevent="sendToReview(makeBundle('reservation'), 'sale-reservation', 'review')" class="btn btn-primary">Submit on review</a>
                    </div>
                  </div>
                </template>
                <template v-if="_is('agencyAdmin') && isReservation_Review()">
                  <div class="row">
                    <div class="col-sm-2">
                    </div>
                  </div>
                </template>
                <template v-if="_is('superAdmin') && isReservation_Review()">
                  <div class="row">
                    <div class="col-sm-2">
                      <a @click.prevent="startSellingProcess()" class="btn btn-primary">Reservation done</a>
                    </div>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </panel>
      </div>
      <!-- selling process -->
      <div class="col-sm-12 col-md-12" v-if="!isProposed() && !isRejected()">
        <panel :title="'Selling process'" v-if="isSelling() || isSold()">
          <!-- uploads -->
          <div class="form-inline">
            <!-- contract draft -->
            <div class="row" v-if="wasReservation()">
              <div class="col-sm-12">
                <div class="row" v-for="(slot, idx) in $fileslot.__getSlotsByCode(object, slotCodes['selling-draft'])" :key="idx">
                  <div class="col-sm-4">
                    <strong>{{slot.title}}:</strong>
                  </div>
                  <div class="col-sm-5">
                    <div class="row">
                      <UploadForm v-if="uploadUrl && canUploadSelling(slot.code)"
                                  accept="*/*"
                                  @uploadComplete="uploadComplete"
                                  @uploadError="uploadError"
                                  :multiple="true"
                                  :label="''"
                                  labelIconClass="icon-add"
                                  :showHint="true"
                                  :uploadUrl="uploadUrl"
                                  :fileSlot="slot.code"
                      ></UploadForm>
                    </div>
                    <div v-if="!canUploadSelling(slot.code) && !slotOkay(slot.code)" class="alert alert-bordered" :class="{'alert-warning': !slotApproved(slot.code, 'sale-selling-slot')}">
                      <p>
                        Waiting for upload by <span class="text-bold">SAAD Immo</span>
                      </p>
                    </div>
                    <div v-else-if="(!slotStatus(slot.code, 'sale-selling-slot').match(/^rejected/) && slotStatus(slot.code, 'sale-selling-slot') === 'submitted') && !slotApproved(slot.code, 'sale-selling-slot')" class="alert alert-bordered" :class="{'alert-warning': !slotApproved(slot.code, 'sale-selling-slot')}">
                      <p v-if="!slotApproved(slot.code, 'sale-selling-slot')">
                        <span class="text-bold">Senior Agent</span> approval pending
                      </p>
                    </div>
                    <template v-else-if="slotStatus(slot.code, 'sale-selling-slot').match(/^rejected/)">
                      <div class="alert alert-bordered alert-danger" :class="{'mb-0': slotStatusReason(slot.code, 'sale-selling-slot')}">
                        <p v-if="slotStatus(slot.code, 'sale-selling-slot') === 'rejected'">
                          <span class="text-bold">Senior Agent</span> rejected documents
                        </p>
                      </div>
                      <div v-if="slotStatusReason(slot.code, 'sale-selling-slot')" class="alert alert-bordered bg-grey">
                        {{slotStatusReason(slot.code, 'sale-selling-slot')}}
                      </div>
                    </template>
                    <div class="row">
                      <model-files-list :fileSlot="slot" :canDeleteFile="canDeleteFile(slot.code)" :files="files" @deleteFile="deleteFile"></model-files-list>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <template v-if="_is('superAdmin') && !slotApproved(slot.code, 'sale-selling-slot') && (slotStatus(slot.code, 'sale-selling-slot') !== 'submitted')">
                      <a @click.prevent="sendSlotToReview(slot.code)" class="btn btn-primary">Submit on review</a>
                    </template>
                    <template v-if="_is('agencyAdmin') && !slotApproved(slot.code, 'sale-selling-slot') && (slotStatus(slot.code, 'sale-selling-slot') === 'submitted')">
                      <template v-if="!slotStatus(slot.code, 'sale-selling-slot').match(/^rejected/)">
                        <a @click.prevent="approveSlot({code: slot.code, title: slot.title, status: 'approved'})" class="btn btn-success mr-10">Approve</a><a @click.prevent="rejectSlot({code: slot.code, title: slot.title, status: 'rejected'})" class="btn btn-danger">Reject</a>
                      </template>
                      <template v-else-if="slotStatus(slot.code, 'sale-selling-slot') === 'rejected'">
                        <div class="alert alert-bordered pt-5">
                          <span class="text-danger mr-10">REJECTED</span> <a class="btn btn-default" title="Undo choice" @click.prevent="unrejectSlot({code: slot.code, title: slot.title, status: 'initial'})"><i class="icon-cross2"></i></a>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- final contract -->
            <div class="row" v-if="wasReservation">
              <div class="col-sm-12">
                <div class="row" v-for="(slot, idx) in $fileslot.__getSlotsByCode(object, slotCodes['selling-final'])" :key="idx">
                  <div class="col-sm-4">
                    <strong>{{slot.title}}:</strong>
                  </div>
                  <div class="col-sm-5">
                    <div class="row">
                      <UploadForm v-if="uploadUrl && canUploadSelling(slot.code)"
                                  accept="*/*"
                                  @uploadComplete="uploadComplete"
                                  @uploadError="uploadError"
                                  :multiple="true"
                                  :label="''"
                                  labelIconClass="icon-add"
                                  :showHint="true"
                                  :uploadUrl="uploadUrl"
                                  :fileSlot="slot.code"
                      ></UploadForm>
                    </div>
                    <div v-if="!canUploadSelling(slot.code) && !slotOkay(slot.code)" class="alert alert-bordered" :class="{'alert-warning': !slotApproved(slot.code, 'sale-selling-slot')}">
                      <p>
                        Waiting for upload by <span class="text-bold">SAAD Immo</span>
                      </p>
                    </div>
                    <div v-else-if="(!slotStatus(slot.code, 'sale-selling-slot').match(/^rejected/) && slotStatus(slot.code, 'sale-selling-slot') === 'submitted') && !slotApproved(slot.code, 'sale-selling-slot')" class="alert alert-bordered" :class="{'alert-warning': !slotApproved(slot.code, 'sale-selling-slot')}">
                      <p v-if="!slotApproved(slot.code, 'sale-selling-slot')">
                        <span class="text-bold">Agency Agent</span> approval pending
                      </p>
                    </div>
                    <template v-else-if="slotStatus(slot.code, 'sale-selling-slot').match(/^rejected/)">
                      <div class="alert alert-bordered alert-danger" :class="{'mb-0': slotStatusReason(slot.code, 'sale-selling-slot')}">
                        <p v-if="slotStatus(slot.code, 'sale-selling-slot') === 'rejected'">
                          <span class="text-bold">Agency Agent</span> rejected documents
                        </p>
                      </div>
                      <div v-if="slotStatusReason(slot.code, 'sale-selling-slot')" class="alert alert-bordered bg-grey">
                        {{slotStatusReason(slot.code, 'sale-selling-slot')}}
                      </div>
                    </template>
                    <div class="row">
                      <model-files-list :fileSlot="slot" :canDeleteFile="canDeleteFile(slot.code)" :files="files" @deleteFile="deleteFile"></model-files-list>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <template v-if="_is('superAdmin') && !slotApproved(slot.code, 'sale-selling-slot') && (slotStatus(slot.code, 'sale-selling-slot') !== 'submitted')">
                      <a @click.prevent="sendSlotToReview(slot.code)" class="btn btn-primary">Submit on review</a>
                    </template>
                    <template v-if="(_is('agencyAgent') || _is('agencyAdmin')) && !slotApproved(slot.code, 'sale-selling-slot') && (slotStatus(slot.code, 'sale-selling-slot') === 'submitted')">
                      <template v-if="!slotStatus(slot.code, 'sale-selling-slot').match(/^rejected/)">
                        <a @click.prevent="approveSlot({code: slot.code, title: slot.title, status: 'approved'})" class="btn btn-success mr-10">Approve</a><a @click.prevent="rejectSlot({code: slot.code, title: slot.title, status: 'rejected'})" class="btn btn-danger">Reject</a>
                      </template>
                      <template v-else-if="slotStatus(slot.code, 'sale-selling-slot') === 'rejected'">
                        <div class="alert alert-bordered pt-5">
                          <span class="text-danger mr-10">REJECTED</span> <a class="btn btn-default" title="Undo choice" @click.prevent="unrejectSlot({code: slot.code, title: slot.title, status: 'initial'})"><i class="icon-cross2"></i></a>
                        </div>
                      </template>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- client receiving the draft -->
            <date-step-view
              v-if="wasReservation()"
              :confirmed="object.client_received_draft_confirmed > 0 || false"
              :title="'Client has received the contract draft'"
              :date-title="'Date of reception'"
              :confirm-role-title="'Senior Agent'"
              :allowed-roles="['agencyAdmin']"
              :value="object.client_received_draft_at"
              :date-field="'client_received_draft_at'"
              :confirmation-required="true"
              :strict-check="true"
              @set="setDateCallback"
              @confirm="confirmCallback"
              @confirmInvalid="confirmFailedCallback"
            />
            <!-- signing contract appointment -->
            <date-step-view
              v-if="wasReservation()"
              :confirmed="object.signing_contract_confirmed > 0 || false"
              :title="'Signing contract appointment'"
              :date-title="'Date of signing'"
              :confirm-role-title="'SAAD Immo'"
              :allowed-roles="['superAdmin']"
              :value="object.signing_contract_at"
              :date-field="'signing_contract_at'"
              :confirmation-required="true"
              :strict-check="true"
              @set="setDateCallback"
              @confirm="confirmCallback"
              @confirmInvalid="confirmFailedCallback"
            />
            <!-- notary confirmed -->
            <date-step-view
              v-if="wasReservation() && object.sign_location === 'cc'"
              :confirmed="object.sent_to_notary_confirmed > 0 || false"
              :title="'Genehmigung signed and sent to notary'"
              :date-title="'Date of signing'"
              :confirm-role-title="'Senior Agent'"
              :allowed-roles="['agencyAdmin']"
              :value="object.sent_to_notary_at"
              :date-field="'sent_to_notary_at'"
              :confirmation-required="true"
              :strict-check="true"
              @set="setDateCallback"
              @confirm="confirmCallback"
              @confirmInvalid="confirmFailedCallback"
            />
            <!-- genehmigung signed -->
            <date-step-view
              v-if="wasReservation()"
              :confirmed="object.paid_confirmed > 0 || false"
              :title="'Payment sent by Client'"
              :date-title="'Date of sending'"
              :confirm-role-title="'Senior Agent'"
              :allowed-roles="['agencyAdmin']"
              :value="object.paid_at"
              :date-field="'paid_at'"
              :confirmation-required="true"
              :strict-check="true"
              @set="setDateCallback"
              @confirm="confirmCallback"
              @confirmInvalid="confirmFailedCallback"
            />
            <template v-if="object.loan_based">
              <!-- payment sent by bank -->
              <date-step-view
                v-if="wasReservation()"
                :confirmed="object.bank_payment_sent_confirmed > 0 || false"
                :title="'Bank sent money'"
                :date-title="'Date of sending'"
                :confirm-role-title="'Senior Agent'"
                :allowed-roles="['agencyAdmin','financeAdmin']"
                :value="object.bank_payment_sent_at"
                :date-field="'bank_payment_sent_at'"
                :confirmation-required="true"
                :strict-check="true"
                @set="setDateCallback"
                @confirm="confirmCallback"
                @confirmInvalid="confirmFailedCallback"
              />
            </template>
            <!-- payment sent by client -->
            <date-step-view
              v-if="wasReservation()"
              :confirmed="object.payment_received_confirmed > 0 || false"
              :title="'Payment received by SAAD'"
              :date-title="'Date of reception'"
              :confirm-role-title="'SAAD Immo'"
              :allowed-roles="['superAdmin']"
              :value="object.payment_received_at"
              :date-field="'payment_received_at'"
              :confirmation-required="true"
              :strict-check="true"
              @set="setDateCallback"
              @confirm="confirmCallback"
              @confirmInvalid="confirmFailedCallback"
            />
          </div>
          <template v-if="_is('superAdmin') && sellingDone() && !isSold()">
            <div class="row">
              <div class="col-sm-2">
                <a @click.prevent="pushSold()" class="btn btn-primary">Selling done!</a>
              </div>
            </div>
          </template>
        </panel>
      </div>
      <div class="col-sm-12 col-md-12" v-if="isSold()">
        <panel :title="'Pay slips'">
          <!-- uploads -->
          <div class="form-inline">
            <div class="row">
              <div class="col-sm-12">
                <div class="row" v-for="(slot, idx) in $fileslot.__getSlotsByCode(object, slotCodes['sold'])" :key="idx">
                  <div class="col-sm-4">
                    <strong>{{slot ? slot.title : 'Pay slips'}}:</strong>
                  </div>
                  <div class="col-sm-5">
                    <div class="row">
                      <UploadForm v-if="uploadUrl && _is('superAdmin')"
                                  accept="*/*"
                                  @uploadComplete="uploadComplete"
                                  @uploadError="uploadError"
                                  :multiple="true"
                                  :label="''"
                                  labelIconClass="icon-add"
                                  :showHint="true"
                                  :uploadUrl="uploadUrl"
                                  :fileSlot="slot ? slot.code : 'paymentSlips'"
                      ></UploadForm>
                    </div>
                    <div class="row">
                      <model-files-list :fileSlot="slot || {'code': 'paymentSlips', 'title': 'Pay slips'}" :canDeleteFile="canDeleteFile(slot ? slot.code : 'paymentSlips')" :files="files" @deleteFile="deleteFile"></model-files-list>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </panel>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import SaleService from '@/services/sale.service'
import ProjectService from '@/services/project.service'
import ApartmentService from '@/services/apartment.service'
import UserService from '@/services/user.service'

import Modal from '@/components/Modal'
import Panel from '@/components/_partial/_atomic/panel'
import ApartmentList from '../apartment/_partial/List'
import UploadForm from '@/components/_partial/UploadForm'
import SecondarySidebar from '@/components/_partial/SecondarySidebar'
import Chat from '@/components/_partial/Chat'
import UserView from '../configuration/users/View'
import ProjectView from '../project/View'
import fileServiceMixin from '@/helpers/mixins/_fileServiceMixin'
import initServiceMixin from '@/helpers/mixins/_initServiceMixin'
import ModelFilesList from '@/components/sale/_partial/ModelFilesList'
import SlotViewCredit from './_partial/SlotViewCredit'
import DateStepView from './_partial/DateStepView'

export default {
  name: 'SaleView',
  components: {
    DateStepView,
    SlotViewCredit,
    ModelFilesList,
    UserView,
    ProjectView,
    SecondarySidebar,
    ApartmentList,
    Panel,
    UploadForm,
    Chat,
    Modal
  },
  mixins: [fileServiceMixin, initServiceMixin],

  props: ['entity', 'oid'],
  data () {
    return {
      id: null,
      object: {},
      agentObject: {},
      projectObject: {},
      files: [],
      /** service **/
      service: SaleService,
      services: {
        'project': ProjectService,
        'apartment': ApartmentService,
        'user': UserService
      },
      uploadUrl: null,
      /** pricing **/
      saleDiscount: 0,
      /** hard refresh **/
      drawComponent: true,
      /** slots **/
      slotCodes: {
        'reservation': [
          'reservationContract',
          'identityProof',
          'addressProof'
        ],
        'selling-draft': [
          'salesContractDraft'
        ],
        'selling-final': [
          'finalSalesContract'
        ],
        'reservation-credit': {
          'belgian': [
            'creditLetter'
          ],
          'german': [
            'idCard',
            'payroll',
            'lastTaxReturn',
            'pensionInfo',
            'assets',
            'schufa'
          ]
        },
        'sold': [
          'paymentSlips'
        ]
      },
      slots: {
        identityProof: false,
        reservationContract: false,
        addressProof: false
      },
      dateFields: {
        'client_received_draft_at': {
          callback: (val) => {
            this.object.client_received_draft_at = val
            this.saveDate('client_received_draft_at')
          },
          confirm: () => {
            this.object.client_received_draft_confirmed = 1
            this.setConfirm('client_received_draft_confirmed')
          }
        },
        'signing_contract_at': {
          callback: (val) => {
            this.object.signing_contract_at = val
            this.saveDate('signing_contract_at')
          },
          confirm: () => {
            this.object.signing_contract_confirmed = 1
            this.setConfirm('signing_contract_confirmed')
          }
        },
        'contract_sent_to_client_at': {
          callback: (val) => {
            this.object.contract_sent_to_client_at = val
            this.saveDate('contract_sent_to_client_at')
          },
          confirm: () => {
            this.object.contract_sent_to_client_confirmed = 1
            this.setConfirm('contract_sent_to_client_confirmed')
          }
        },
        'sent_to_notary_at': {
          callback: (val) => {
            this.object.sent_to_notary_at = val
            this.saveDate('sent_to_notary_at')
          },
          confirm: () => {
            this.object.sent_to_notary_confirmed = 1
            this.setConfirm('sent_to_notary_confirmed')
          }
        },
        'paid_at': {
          callback: (val) => {
            this.object.paid_at = val
            this.saveDate('paid_at')
          },
          confirm: () => {
            this.object.paid_confirmed = 1
            this.setConfirm('paid_confirmed')
          }
        },
        'bank_payment_sent_at': {
          callback: (val) => {
            this.object.bank_payment_sent_at = val
            this.saveDate('bank_payment_sent_at')
          },
          confirm: () => {
            this.object.bank_payment_sent_confirmed = 1
            this.setConfirm('bank_payment_sent_confirmed')
          }
        },
        'payment_received_at': {
          callback: (val) => {
            this.object.payment_received_at = val
            this.saveDate('payment_received_at')
          },
          confirm: () => {
            this.object.payment_received_confirmed = 1
            this.setConfirm('payment_received_confirmed')
          }
        }
      },
      addApartmentMode: false,
      needToRefreshOnClose: false
    }
  },

  computed: {},

  updated () {
    for (let i in this.dateFields) {
      if (this.object.hasOwnProperty(i) && (!this.object[i] || this.object[i] === null)) {
        this.object[i] = this.$moment().format(this.localizedFormat.date)
      }
    }
  },

  mounted () {
    this.localizedFormat = Vue.config.localizedFormat
    this.refresh()
  },

  beforeDestroy () {
    // eslint-disable-next-line
    $('.sidebar-secondary').remove()
  },

  beforeMount () {
    // this.object = Object.assign({}, this.service.__itemTemplate)
  },

  methods: {
    specialChanged (special) {
      let specialObject = {}
      console.log(special)
      if (Array.isArray(special) && special.length) {
        specialObject = special[0]
      } else {
        specialObject = special
      }
      console.log(specialObject)
      if (typeof specialObject === 'object') {
        for (let prop in specialObject) {
          console.log(prop, specialObject[prop])
          if (this.object.hasOwnProperty(prop)) {
            this.object[prop] = specialObject[prop]
          }
        }
        this.saveState()
      }
    },

    sellingDone () {
      let result = true
      for (let i in this.dateFields) {
        let field = i.replace(/_at$/, '_confirmed')
        if (field === 'contract_sent_to_client_confirmed') {
          continue
        }
        if (field === 'bank_payment_sent_confirmed' && this.object.loan_based !== 1) {
          continue
        }
        if (this.object.hasOwnProperty(field)) {
          result = result && this.object[field] > 0
        }
      }
      return result
    },

    setDateCallback (object) {
      if (typeof object === 'object') {
        if (object.hasOwnProperty('field') && object.hasOwnProperty('value')) {
          if (this.dateFields.hasOwnProperty(object.field)) {
            this.dateFields[object.field].callback(object.value)
          }
        }
      }
    },
    confirmCallback (object) {
      if (typeof object === 'object') {
        if (object.hasOwnProperty('field')) {
          if (this.dateFields.hasOwnProperty(object.field)) {
            this.dateFields[object.field].confirm()
          }
        }
      }
    },
    confirmFailedCallback () {
      this.$popup.warning('Confirmation failed because date set is in future', 'Failed')
    },
    /**
     * status methods
     **/
    /** WAS OFFER **/
    wasOffer () {
      let result = this.$workflow.getSubflowStatus(this.object, 'sale-offer', 'sale') === 'approved'
      result = result || this.isReservation() || this.isSelling() || this.isSold()
      return result
    },
    wasOffer_Accepted () {
      let result = this.wasOffer()
      return result
    },
    /** WAS RESERVATION **/
    wasReservation () {
      return this.$workflow.isInPassed(this.$workflow.getPassed(this.object, 'sale'), 'reservation')
    },
    wasReservation_Preparation () {
      let result = this.wasReservation() || this.isReservation_Review()
      if (this.$workflow.subflowActive(this.object, 'sale-reservation', 'sale')) {
        result = result && this.$workflow.subflowStatusIn(['review'], this.object, 'sale-reservation', 'sale')
      }
      return result
    },
    /** WAS SELLING **/
    wasSelling () {
      return this.$workflow.isInPassed(this.$workflow.getPassed(this.object, 'sale'), 'selling')
    },
    wasSelling_ContractPreparation () {
      let result = this.isSold()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result || this.$workflow.isInPassed(this.$workflow.getSubflowPassed(this.object, 'sale-selling', 'sale'), 'preparation')
      }
      return result
    },
    wasSelling_Review () {
      let result = this.isSold()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result || this.$workflow.isInPassed(this.$workflow.getSubflowPassed(this.object, 'sale-selling', 'sale'), 'review')
      }
      if (!result) {
        result = result || this.isSelling_Review()
      }
      return result
    },
    wasSelling_ContractSigning () {
      let result = this.isSold()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result || this.$workflow.isInPassed(this.$workflow.getSubflowPassed(this.object, 'sale-selling', 'sale'), 'signing_contract')
      }
      if (!result) {
        result = result || this.isSelling_ContractSigning()
      }
      return result
    },
    wasSelling_ClientReceivedTheDraft () {
      let result = this.isSold()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result || this.$workflow.isInPassed(this.$workflow.getSubflowPassed(this.object, 'sale-selling', 'sale'), 'draft_to_client')
      }
      if (!result) {
        result = result || this.isSelling_ClientReceivedTheDraft()
      }
      return result
    },
    wasSelling_ContractSentToClient () {
      let result = this.isSold()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result || this.$workflow.isInPassed(this.$workflow.getSubflowPassed(this.object, 'sale-selling', 'sale'), 'contract_to_client')
      }
      if (!result) {
        result = result || this.isSelling_ContractSentToClient()
      }
      return result
    },
    wasSelling_Approved () {
      let result = this.isSold()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result || this.$workflow.isInPassed(this.$workflow.getSubflowPassed(this.object, 'sale-selling', 'sale'), 'approved')
      }
      if (!result) {
        result = result || this.isSelling_Approved()
      }
      return result
    },
    wasSelling_GenehmigungSigned () {
      let result = this.isSold()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result || this.$workflow.isInPassed(this.$workflow.getSubflowPassed(this.object, 'sale-selling', 'sale'), 'genehmigung_signed')
      }
      if (!result) {
        result = result || this.isSelling_GenehmigungSigned()
      }
      return result
    },
    wasSelling_PaymentSent () {
      let result = this.isSold()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result || this.$workflow.isInPassed(this.$workflow.getSubflowPassed(this.object, 'sale-selling', 'sale'), 'payment_sent')
      }
      if (!result) {
        result = result || this.isSelling_PaymentSent()
      }
      return result
    },
    wasSelling_PaymentReceived () {
      let result = this.isSold()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result || this.$workflow.isInPassed(this.$workflow.getSubflowPassed(this.object, 'sale-selling', 'sale'), 'payment_received')
      }
      if (!result) {
        result = result || this.isSelling_PaymentReceived()
      }
      if (!result) {
        result = result || this.isSold()
      }
      return result
    },

    /** IS PROPOSED **/
    isProposed () {
      return this.isOffer_Proposed()
    },
    /** IS OFFER **/
    isOffer () {
      return this.$workflow.getFlowStatus(this.object) === 'offer'
    },
    isOffer_Proposed () {
      return this.$workflow.getSubflowStatus(this.object, 'sale-offer', 'sale') === 'created'
    },
    /** IS RESERVATION **/
    isReservation () {
      return this.$workflow.getFlowStatus(this.object) === 'reservation'
    },
    isReservation_Preparation () {
      let result = this.isReservation()
      if (this.$workflow.subflowActive(this.object, 'sale-reservation', 'sale')) {
        result = result && this.$workflow.subflowStatusIn(['preparation'], this.object, 'sale-reservation', 'sale')
      }
      return result
    },
    isReservation_Review () {
      let result = this.isReservation()
      if (this.$workflow.subflowActive(this.object, 'sale-reservation', 'sale')) {
        result = result && this.$workflow.subflowStatusIn(['review'], this.object, 'sale-reservation', 'sale')
      }
      return result
    },
    /** IS SELLING **/
    isSelling () {
      return this.$workflow.getFlowStatus(this.object) === 'selling'
    },
    isSelling_Review () {
      let result = this.isSelling()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result &&
          this.$workflow.subflowStatusIn(['review'], this.object, 'sale-selling', 'sale')
      }
      return result
    },
    isSelling_Approved () {
      let result = this.isSelling()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result &&
          this.$workflow.subflowStatusIn(['approved'], this.object, 'sale-selling', 'sale')
      }
      return result
    },
    isSelling_GenehmigungSigned () {
      let result = this.isSelling()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result &&
          this.$workflow.subflowStatusIn(['genehmigung_signed'], this.object, 'sale-selling', 'sale')
      }
      return result
    },
    isSelling_PaymentSent () {
      let result = this.isSelling()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result &&
          this.$workflow.subflowStatusIn(['payment_sent'], this.object, 'sale-selling', 'sale')
      }
      return result
    },
    isSelling_PaymentReceived () {
      let result = this.isSelling()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result &&
          this.$workflow.subflowStatusIn(['payment_received'], this.object, 'sale-selling', 'sale')
      }
      if (!result) {
        result = result || this.isSold()
      }
      return result
    },
    isSelling_ContractSigning () {
      let result = this.isSelling()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result &&
          this.$workflow.subflowStatusIn(['signing_contract'], this.object, 'sale-selling', 'sale')
      }
      return result
    },
    isSelling_ClientReceivedTheDraft () {
      let result = this.isSelling()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result &&
          this.$workflow.subflowStatusIn(['draft_to_client'], this.object, 'sale-selling', 'sale')
      }
      return result
    },
    isSelling_ContractSentToClient () {
      let result = this.isSelling()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result &&
          this.$workflow.subflowStatusIn(['contract_to_client'], this.object, 'sale-selling', 'sale')
      }
      return result
    },
    isSelling_ContractPreparation () {
      let result = this.isSelling()
      if (this.$workflow.subflowActive(this.object, 'sale-selling', 'sale')) {
        result = result && this.$workflow.subflowStatusIn(['preparation'], this.object, 'sale-selling', 'sale')
      }
      return result
    },
    /** IS SOLD **/
    isSold () {
      return this.$workflow.getFlowStatus(this.object) === 'sold'
    },
    /** IS REJECTED **/
    isRejected () {
      return ['canceled', 'rejected'].indexOf(this.$workflow.getFlowStatus(this.object)) > -1
    },
    /** /status methods **/

    /** sale status push **/
    pushSelling_ContractDraftDone (callback = null) {
      this.service.workflowUpdate(this.object.id, {
        status: 'review',
        workflow: 'sale-selling'
      }, () => {
        if (typeof callback === 'function') {
          callback()
        }
        this.refreshFromServer()
      })
    },
    pushSelling_ContractFinalDone (callback = null) {
      this.service.workflowUpdate(this.object.id, {
        status: 'approved',
        workflow: 'sale-selling'
      }, () => {
        if (typeof callback === 'function') {
          callback()
        }
        this.refreshFromServer()
      })
    },
    pushSelling_ClientReceivedTheDraft (callback = null) {
      this.service.workflowUpdate(this.object.id, {
        status: 'draft_to_client',
        workflow: 'sale-selling'
      }, () => {
        if (typeof callback === 'function') {
          callback()
        }
        this.refreshFromServer()
      })
    },
    pushSelling_ContractSigning (callback = null) {
      this.service.workflowUpdate(this.object.id, {
        status: 'signing_contract',
        workflow: 'sale-selling'
      }, () => {
        if (typeof callback === 'function') {
          callback()
        }
        this.refreshFromServer()
      })
    },
    pushSelling_ContractSentToClient (callback = null) {
      this.service.workflowUpdate(this.object.id, {
        status: 'contract_to_client',
        workflow: 'sale-selling'
      }, () => {
        if (typeof callback === 'function') {
          callback()
        }
        this.refreshFromServer()
      })
    },
    pushSelling_GenehmigungSigned (callback = null) {
      this.service.workflowUpdate(this.object.id, {
        status: 'genehmigung_signed',
        workflow: 'sale-selling'
      }, () => {
        if (typeof callback === 'function') {
          callback()
        }
        this.refreshFromServer()
      })
    },
    pushSelling_PaymentSent (callback = null) {
      this.service.workflowUpdate(this.object.id, {
        status: 'payment_sent',
        workflow: 'sale-selling'
      }, () => {
        if (typeof callback === 'function') {
          callback()
        }
        this.refreshFromServer()
      })
    },
    pushSelling_PaymentReceived (callback = null) {
      this.service.workflowUpdate(this.object.id, {
        status: 'payment_received',
        workflow: 'sale-selling'
      }, () => {
        if (typeof callback === 'function') {
          callback()
        }
        this.refreshFromServer()
      })
    },
    pushSold () {
      this.service.workflowUpdate(this.object.id, {
        status: 'sold',
        workflow: 'sale'
      }, () => {
        this.refreshFromServer()
      })
    },
    /** /sale status push **/

    deleteApartmentClick (id) {
      this.$popup.confirm('Are you sure to remove this apartment from offer?', 'Remove apartment').then(() => {
        this.service.removeApartments(this.object.id, [id], (result) => {
          this.$popup.success('Apartment was successfully removed from this offer', 'Success')
          this.refreshFromServer()
        })
      })
    },

    addApartmentClick () {
      this.addApartmentMode = true
    },

    selectApartmentClick (item) {
      let id = null
      if (typeof item === 'object' && item.hasOwnProperty('id')) {
        id = item.id
      } else {
        id = item
      }
      if (id !== null) {
        this.service.addApartments(this.object.id, [id], (result) => {
          this.$popup.success('Apartment was successfully added to the offer', 'Success')
          this.needToRefreshOnClose = true
        }, (error) => {
          this.$popup.error(error.body.message)
        })
      }
    },

    addApartmentClose () {
      this.addApartmentMode = false
      if (this.needToRefreshOnClose) {
        this.needToRefreshOnClose = false
        this.refreshFromServer()
      }
    },

    addApartment (id) {
      this.service.addApartments(this.object.id, [id], (result) => {
        this.$popup.success('Apartment was successfully added to the offer', 'Success')
        this.refresh()
      }, (error) => {
        this.$popup.error(error.body.message)
      })
    },

    junkFiles () {
      return this.files.filter(f => {
        return !f.slot
      })
    },

    discountChanged (val) {
      this.object.discount = val
      this.showLoader = true
      let data = this.prepareData(this.object)
      this.service.update(this.object.id, data, () => {
        this.showLoader = false
      })
    },

    flowState () {
      return this.$workflow.__getFlowStateByFlowName(this.object)
    },

    canUploadSelling (slotCode) {
      let result = false
      if (this.isRejected()) {
        return result
      }
      if (this.isSelling() && this._is('superAdmin')) {
        if (!this.slotStatusIn(['submitted', 'approved'], slotCode, 'sale-selling-slot')) {
          result = true
        }
      }
      return result
    },

    isAuthor (object) {
      return typeof object === 'object' && object.hasOwnProperty('created_by') && parseInt(object.created_by) === parseInt(this.$store.getters.userId)
    },

    canUpload (slotCode = null, flow = 'sale-slot') {
      let result = false
      if (this.isRejected()) {
        return result
      }
      if (this.isOffer()) {
        if (this.wasOffer_Accepted()) {
          result = true
        }
      } else {
        if (slotCode !== null) {
          if (this.isReservation()) {
            if (this.slotStatusIn(['initial', 'rejected_by_saad', 'rejected_by_senior', 'rejected'], slotCode, flow) || !this.$fileslot.getSlotWorkflowState(this.object, slotCode)) {
              result = true
            }
          }
        } else {
          if (this.isReservation_Preparation()) {
            result = true
          }
        }
      }
      // result = result && parseInt(this.object.created_by) === parseInt(this.$store.getters.userId)
      return result
    },

    canChangeReservation () {
      let result = false
      if (this.isRejected()) {
        return result
      }
      if (this.isOffer() || this.isReservation()) {
        result = this.isAuthor(this.object) || this._is('superAdmin') || this._is('agencyAdmin')
      }
      if (this.isSold()) {
        result = false
      }
      return result
    },

    canSubmitOffer () {
      return (this._is('agencyAgent') || this._is('agencyAdmin') || this._is('superAdmin') || this.object.created_by === parseInt(this.$store.getters.userId)) && !this.isRejected() && !this.isSold()
    },

    canDeleteFile (slotCode = null) {
      if (!this.wasReservation()) {
        return this.canSubmitOffer() && this.canChangeReservation()
      }
      if (slotCode !== null) {
        if (this.isSelling() && this._is('superAdmin')) {
          if (this.slotStatus(slotCode, 'sale-selling-slot') !== 'submitted') {
            return true
          }
        }
      }
      return false
    },

    deleteFile (fileId) {
      this.$popup.confirm('Are you sure to delete this file?').then(() => {
        this.service.detachFiles(this.object.id, [fileId], () => {
          this.$popup.success('File removed successfully')
          this.saveState().then(() => {
            this.refresh(true)
          })
        }, () => {
          this.$popup.error('File couldn\'t be deleted')
        })
      })
    },

    downloadPreReservation (empty = false) {
      this.service.makePreReservation(this.object.id, empty ? 1 : 0, () => {
        let url = Vue.config.API_BASE_URL.replace('v1/', '') + 'uploads/prt-' + this.object.id + '-' + this.object.language + (empty ? '-template' : '') + '.pdf'
        let a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        a.download = url
        a.target = '_blank'
        document.body.appendChild(a)
        a.click()
      })
    },

    acceptReservation () {
      if (this.acceptReservationPossible()) {
        this.$popup.confirm('Are you sure you want to accept reservation?', 'Confirm').then(() => {
          this.service.workflowUpdate(this.object.id, {
            status: 'accepted',
            workflow: 'sale-offer'
          }, () => {
            this.refreshFromServer(true)
          })
        })
      } else {
        this.$popup.confirm('All apartments included to this offer are reserved by another person. Do you want to cancel offer?', 'Confirm').then(() => {
          let reason = 'Apartments reserved by other agent'
          this.service.workflowUpdate(this.object.id, 'declined', 'sale-offer', () => {
            this.service.workflowUpdate(this.object.id, {
              status: 'rejected',
              workflow: 'sale',
              reason: reason
            }, () => {
              this.refresh(true)
            })
          })
        })
      }
    },

    acceptReservationPossible () {
      let result = true
      this.object.apartments.forEach((el, idx) => {
        if (el.status > 1) {
          result = false
        }
      })
      return result
    },

    declineReservation () {
      this.$popup.confirm('Are you sure you want to decline reservation?', 'Confirm').then(() => {
        this.$popup.inputText(null, 'Enter declining reason').then((result) => {
          let reason = result
          this.service.workflowUpdate(this.object.id, 'declined', 'sale-offer', () => {
            this.service.workflowUpdate(this.object.id, {
              status: 'rejected',
              workflow: 'sale',
              reason: reason
            }, () => {
              this.refreshFromServer()
            })
          })
        })
      })
    },

    approveSlot (data) {
      if (typeof data === 'object') {
        let code = data.code || null
        let status = data.status || null
        let callback = data.callback || null
        if (code !== null) {
          this.$popup.confirm('Do you want to confirm ' + data.title + '?', 'Document confirmation').then(() => {
            this.service.slotWorkflowUpdate(this.object.id, code, { status: status || (this._is('superAdmin') ? 'approved_by_saad' : 'approved_by_senior') }, () => {
              if (typeof callback === 'function') {
                callback()
              }
              this.$popup.success(data.title + ' has been approved', 'Document confirmation')
              this.refreshFromServer()
            })
          })
        }
      }
    },

    rejectSlot (data) {
      if (typeof data === 'object') {
        let code = data.code || null
        let status = data.status || null
        let callback = data.callback || null
        this.$popup.confirm('Do you want to reject ' + data.title + '?', 'Document rejection', 'warning').then(() => {
          this.$popup.inputText(null, 'Type rejection reason').then((result) => {
            let reason = result
            this.service.slotWorkflowUpdate(this.object.id, code, {
              'status': status || (this._is('superAdmin') ? 'rejected_by_saad' : 'rejected_by_senior'),
              'reason': reason
            }, () => {
              if (typeof callback === 'function') {
                callback()
              }
              this.refreshFromServer()
            })
          })
        })
      }
    },

    unrejectSlot (data) {
      if (typeof data === 'object') {
        let code = data.code || null
        this.$popup.confirm('Are you sure you want to undo reject of these documents?', 'Confirm action').then(() => {
          this.service.slotWorkflowUpdate(this.object.id, code, { status: 'submitted' }, () => {
            this.refreshFromServer()
          })
        })
      }
    },

    startSellingProcess () {
      this.$popup.confirm('Are you sure to confirm reservation and start selling process?').then(() => {
        this.service.workflowUpdate(this.object.id, {
          status: 'approved',
          workflow: 'sale-reservation'
        }, () => {
          this.refreshFromServer()
        }, () => {
          this.$popup.error('All documents have not been successfully approved yet.', 'Reservation Approval Error')
        })
      })
    },

    approveSlotsFinal (slotsBundle = 'reservation') {
      if (this._is('superAdmin')) {
        let slotsToSubmit = this.slotCodes[slotsBundle]
        let promises = []
        slotsToSubmit.forEach((el) => {
          if (!this.$fileslot.slotFilled(this.object, el) && this.slots[el] !== true) {
          } else {
            promises.push(this.service.slotWorkflowUpdate(this.object.id, el, { status: 'approved_by_saad' }, () => {
            }, () => {
            }))
          }
        })
        Promise.all(promises).then(() => {
          this.service.workflowUpdate(this.object.id, {
            status: 'approved',
            workflow: 'sale-reservation'
          }, () => {
            this.refreshFromServer()
          })
        })
      }
    },

    approveSlots (slotsBundle = 'reservation') {
      if (this._is('agencyAdmin')) {
        let slotsToSubmit = ['reservation', 'passport', 'addressProof']
        let slotsOkay = true
        let promises = []
        let submitErrors = 0
        slotsToSubmit.forEach((el) => {
          if (!this.$fileslot.slotFilled(this.object, el) && this.slots[el] !== true) {
            slotsOkay = false
          } else {
            promises.push(this.service.slotWorkflowUpdate(this.object.id, el, { status: 'approved_by_senior' }, () => {
            }, () => {
              submitErrors++
            }))
          }
        })
        this.$logger.log('approveSlots', [slotsOkay, submitErrors])

        Promise.all(promises).then(() => {
          this.refreshFromServer()
        })
      }
    },

    sendSlotToReview (slotCode = null) {
      if (slotCode !== null) {
        this.service.slotWorkflowUpdate(this.object.id, slotCode, { status: 'submitted' }, () => {
          this.$popup.success('Documents has been sent to review successfully')
          this.refresh(true)
        })
      }
    },

    sendToFinalReview (slotsBundle = 'reservation', workflow = 'sale-reservation', targetStatus = 'review') {
      this.$popup.confirm('Are you sure you want to submit documents on review?', 'Confirm').then(() => {

      })
    },

    makeBundle (slotsBundle = 'reservation') {
      let result = this.slotCodes[slotsBundle]
      if (this.object.bank_belgian > 0) {
        result = result.concat(this.slotCodes['reservation-credit']['belgian'])
      }
      if (this.object.bank_german > 0) {
        result = result.concat(this.slotCodes['reservation-credit']['german'])
      }
      return result
    },

    sendToReview (slotsBundle = 'reservation', workflow = 'sale-reservation', targetStatus = 'review') {
      this.$popup.confirm('Are you sure you want to submit documents on review?', 'Confirm').then(() => {
        let data = this.prepareData(this.object)
        let slotsToSubmit = []
        if (Array.isArray(slotsBundle)) {
          slotsToSubmit = slotsBundle
        } else {
          slotsToSubmit = this.slotCodes[slotsBundle]
        }
        let slotsOkay = true
        let promises = []
        let submitErrors = 0
        let BreakException = {}
        try {
          slotsToSubmit.forEach((el) => {
            if (!this.$fileslot.slotFilled(this.object, el)) {
              slotsOkay = false
              throw BreakException
            } else {
              if (this.$fileslot.getSlotWorkflowState(this.object, el)) {
                promises.push(this.service.slotWorkflowUpdate(this.object.id, el, { status: 'submitted' }, () => {
                }, () => {
                  submitErrors++
                }))
              }
            }
          })
        } catch (e) {
          if (e !== BreakException) {
            throw e
          }
        }
        if (!slotsOkay) {
          this.$popup.error('All documents must be uploaded to submit them to review.', 'Not enough data')
        } else {
          Promise.all(promises).then(
            this.service.workflowUpdate(this.object.id, {
              status: targetStatus,
              workflow: workflow
            }, () => {
              this.service.update(this.object.id, data, () => {
                this.$popup.success('Reservation documents submitted on review', 'Success').then(() => {
                  this.refresh(true)
                })
              })
            }, () => {
              this.$popup.error('Cannot send documents to review...', 'Something going wrong')
            })
          ).catch(() => {
            if (submitErrors > 0) {
              this.$popup.error('Some documents has not been submitted')
            }
          })
        }
      })
    },

    hardReset () {
      let vm = this
      vm.drawComponent = false
      Vue.nextTick(() => {
        vm.drawComponent = true
        // this.makeIdFilter()
        this.object = this.object
      })
    },

    refreshFromServer () {
      this.service.item(this.oid, result => {
        for (let i in result) {
          if (result.hasOwnProperty(i)) {
            this.object[i] = result[i]
          }
        }
        /* this.object.language = this.object.language || 'en'
        this.object.loan = this.object.loan || 0
        this.object.sign_location = this.object.sign_location || 'cc' */
        //
        this.id = this.object.id
        this.uploadUrl = Vue.config.endpoints.sale.attachFiles.replace('{:id}', this.id)
        this.files = this.object.modelFiles || []
        this.$emit('loadObject', this.object)
        this.$emit('shown', this.object)
        //
        if (!this.projectObject || !this.projectObject.hasOwnProperty('id')) {
          if (parseInt(this.object.project_id)) {
            this.services['project'].item(this.object.project_id, (result) => {
              this.projectObject = result
              console.log(this.$fileslot.__getSlotsByCode(this.object, this.slotCodes['reservation']))
            })
          } else {
            if (Array.isArray(this.object.apartments) && this.object.apartments.length) {
              this.services['project'].item(this.object.apartments[0].project_id, (result) => {
                this.projectObject = result
                this.service.update(this.object.id, { project_id: this.projectObject.id })
              })
            }
          }
        }
        //
        if (!this.agentObject.hasOwnProperty('id')) {
          this.services['user'].item(this.object.created_by, (result) => {
            this.agentObject = result
          })
        }
        //
        this.hardReset()
      })
    },

    refresh (hardRefresh = false, newInstance) {
      if ((!this.object.id && this.oid) || hardRefresh) {
        this.refreshFromServer()
      } else {
        if (newInstance) {
          for (let i in newInstance) {
            if (newInstance.hasOwnProperty(i)) {
              this.object[i] = newInstance[i]
            }
          }
          this.id = this.object.id
          this.$emit('assignObject', this.object)
          this.$emit('shown', this.object)
        }
        this.$emit('shown', this.object)
      }
      if (this.object.hasOwnProperty('id')) {
        this.id = this.object.id
      }
      //
      if (parseInt(this.object.project_id)) {
        this.services['project'].item(this.object.project_id, (result) => {
          this.projectObject = result
        })
      } else {
        if (!this.projectObject || !this.projectObject.hasOwnProperty('id')) {
          if (Array.isArray(this.object.apartments) && this.object.apartments.length) {
            this.services['project'].item(this.object.apartments[0].project_id, (result) => {
              this.projectObject = result
              this.service.update(this.object.id, { project_id: this.projectObject.id })
            })
          }
        }
      }
      //
    },

    prepareData (object) {
      let data = {}
      for (let i in this.object) {
        if (Object.keys(this.dateFields).indexOf(i) > -1 || typeof this.object[i] === 'object' || Array.isArray(this.object[i]) || ['created_by', 'updated_by'].indexOf(i) > -1) {
          continue
        }
        data[i] = this.object[i]
        if (data[i] === true) {
          data[i] = 1
        } else if (data[i] === false) {
          data[i] = 0
        }
      }
      return data
    },

    saveState () {
      return new Promise((resolve, reject) => {
        this.service.update(this.object.id, this.prepareData(this.object), (data) => {
          resolve(data)
        }, (err) => {
          reject(err)
        })
      })
    },

    saveDate (field) {
      if (this.object.hasOwnProperty(field)) {
        let data = {}
        data[field] = this.$moment(this.object[field], this.localizedFormat.date).format('YYYY-MM-DD')
        this.service.update(this.object.id, data)
      }
    },

    setConfirm (field) {
      if (this.object.hasOwnProperty(field)) {
        let data = {}
        data[field] = 1
        this.service.update(this.object.id, data, () => {
          this.refreshFromServer()
        })
      }
    },

    uploadComplete (fileUpload) {
      this.$logger.log('uploadComplete', fileUpload)

      let file = fileUpload.uploaded || null
      if (!file) {
        this.$popup.warning('Uploaded file is not an file')
        return
      }

      file.isNew = true
      this.files.push(file)
      this.saveState()
    },

    uploadError (file) {
      this.$logger.log('uploadError', file)
      this.$popup.warning('Failed to upload file')
    },

    slotOkay (slotCode) {
      if (this.object) {
        return this.$fileslot.slotFilled(this.object, slotCode)
      }
      return false
    },

    slotApproved (slot, workflow = 'sale-credit-slot') {
      let targetState = ['approved']
      return this.slotStatusIn(targetState, slot, workflow)
    },

    slotApprovedBy (role, slot, workflow = 'sale-slot') {
      let targetState = ['approved_by_saad']
      if (role === 'agencyAdmin') {
        targetState.unshift('approved_by_senior')
      }
      return this.slotStatusIn(targetState, slot, workflow)
    },

    slotsApprovedBy (role, slots) {
      let result = true
      for (let i in slots) {
        result = this.slotApprovedBy(role, slots[i])
        if (!result) {
          break
        }
      }
      return result
    },

    slotStatusIn (statuses, slotCode, workflow = 'sale-slot') {
      let result = false
      if (Array.isArray(statuses)) {
        for (let i in statuses) {
          if (statuses[i] === this.slotStatus(slotCode, workflow)) {
            result = true
          }
        }
      }
      return result
    },

    slotStatus (slotCode, workflow = 'sale-slot') {
      let slotObject = this.$fileslot.__getSlotByCode(this.object, slotCode)
      let result = ''
      if (slotObject) {
        result = this.$workflow.getFlowStatus(slotObject, workflow)
      }
      return result || ''
    },

    slotStatusReason (slotCode, workflow = 'sale-slot') {
      let slotObject = this.$fileslot.__getSlotByCode(this.object, slotCode)
      let result = ''
      if (slotObject) {
        result = this.$workflow.getFlowStatusReason(slotObject, workflow)
      }
      return result || ''
    }
  }
}
</script>

<style scoped>

</style>
